<template>
<div :class="[style.box, { [style.hideContent]: hideContent }]">
	<div v-if="title" :class="style.title" :style="titleStyle">
		{{ title }}
	</div>
	<div :class="style.content">
		<slot />
	</div>
</div>
</template>

<script lang="ts">
import { computed, defineComponent, useCssModule } from 'vue'

export default defineComponent({
	props: {
		title: {
			type: String,
			required: false,
		},
		titleColor: {
			type: String,
			required: false,
		},
		hideContent: {
			type: Boolean,
			default: false,
		},
	},
	setup: ({ title, titleColor, hideContent }) => ({
		style: useCssModule(),
		title,
		titleStyle: computed(() => (
			titleColor ? {
				backgroundColor: titleColor,
			} : {
			}
		)),
		hideContent,
	})
})
</script>

<style lang="scss" module>
.box {
	border-radius: 8px;
	border: 1px solid gainsboro;
	background-color: whitesmoke;
	color: lightslategray;
	margin-bottom: 12px;
}

.title {
	padding: 10px;
	margin: -1px -1px 0;
	border-radius: inherit;
	color: #eee;
	font-size: 1.2em;
	font-weight: bold;
	text-align: center;
	border-bottom-left-radius: 0;
	border-bottom-right-radius: 0;
}

.content {
	display: flex;
	margin: 12px;
	flex-flow: column;
	align-items: stretch;

	& > *:first-child {
		margin-top: 0px;
	}
}

.hideContent {
	.title {
		margin-bottom: -1px;
		border-bottom-left-radius: inherit;
		border-bottom-right-radius: inherit;
	}

	.content {
		display: none;
	}
}
</style>
